import { InvoiceToSubconPreviewDetailPDF } from 'containers/SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/InvoiceToSubconPreviewDetailPDF';
import React, { lazy } from 'react';

const CNtoSubconPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/CNtoSubconPreviewDetailPDF'
  ).then(module => ({
    default: module.CNtoSubconPreviewDetailPDF,
  })),
);

const DNtoSubconPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/DNtoSubconPreviewDetailPDF'
  ).then(module => ({
    default: module.DNtoSubconPreviewDetailPDF,
  })),
);

const SubconPreviewDetailPDF = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF'
  ).then(module => ({
    default: module.SubconPreviewDetailPDF,
  })),
);
const InvoiceToSubconPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/InvoiceToSubconPreviewDetailPDF'
  ).then(module => ({
    default: module.InvoiceToSubconPreviewDetailPDF,
  })),
);

const SubcontractAdvancePreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconAdvancePreviewDetailPDF'
  ).then(module => ({
    default: module.SubconAdvancePreviewDetailPDF,
  })),
);

const SubconProgressClaimPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconProgressClaimPreviewDetailPDF'
  ).then(module => ({
    default: module.SubconProgressClaimPreviewDetailPDF,
  })),
);
const SubconProgressClaimPDF = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconProgressClaimPDF'
  ).then(module => ({
    default: module.SubconProgressClaimPDF,
  })),
);

const SubconRetentionClaimPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconRetentionClaimPreviewDetailPDF'
  ).then(module => ({
    default: module.SubconRetentionClaimPreviewDetailPDF,
  })),
);

const SubcontractPaymentPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconPaymentsPreviewDetailPDF'
  ).then(module => ({ default: module.SubconPaymentsPreviewDetailPDF })),
);

const SubcontractRefundsPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconRefundsPreviewDetailPDF'
  ).then(module => ({
    default: module.SubconRefundsPreviewDetailPDF,
  })),
);

const subContractELetterRoutes = [
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/cn-to-subcon/:transactionID/preview',
    },
    component: (
      <CNtoSubconPreview
        accountType="subcontractor"
        transactionType="Credit Notes to Subcon"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/dn-to-subcon/:transactionID/preview',
    },
    component: (
      <DNtoSubconPreview
        accountType="subcontractor"
        transactionType="Debit Notes to Subcon"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/invoices-to-subcon/:transactionID/preview',
    },
    component: (
      <InvoiceToSubconPreviewDetailPDF
        accountType="subcontractor"
        transactionType="Invoice to Subcon"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/subcon-advance/:transactionID/preview',
    },
    component: (
      <SubcontractAdvancePreview
        transactionType="Advances"
        accountType="subcontractor"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/subcon-payment/:transactionID/preview',
    },
    component: (
      <SubcontractPaymentPreview
        transactionType="Payments"
        accountType="subcontractor"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/subcon-claim/:transactionID/preview',
    },
    component: (
      <SubconProgressClaimPDF
        accountType="subcontractor-account"
        transactionType="progress-claims"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/subcontractor-account/account-transaction/:subcontractorID/:subcontractID/subcon-refund/:transactionID/preview',
    },
    component: (
      <SubcontractRefundsPreview
        accountType="subcontractor"
        transactionType="Refunds"
      />
    ),
  },
  ////////////////////ELETTER PREVIEW PDF///////////////
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/cn-to-subcon/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="credit-note"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/dn-to-subcon/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="debit-note"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/invoices-to-subcon/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="invoice"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/subcon-advance/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="advances"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/subcon-claim/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="claim-all"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:id/costing/:type/progress-claims/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="claim-all"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/subcon-payment/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="payment"
        accountType="subcontractor-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/subcon-refund/:transactionID/e-letter',
    },
    component: (
      <SubconPreviewDetailPDF
        docType="refund"
        accountType="subcontractor-account"
      />
    ),
  },
];

export default subContractELetterRoutes;
